export default [
    {
        path: '/pages/phone/communityRecommend',
        name: '/pages/phone/communityRecommend',
        component: () => import('@/views/phone/communityRecommend.vue')
    },
    {
        path: '/pages/phone/indexMenu',
        name: '/pages/phone/indexMenu',
        component: () => import('@/views/phone/indexMenu.vue')
    },
    {
        path: '/pages/phone/storeAdsManage',
        name: '/pages/phone/storeAdsManage',
        component: () => import('@/views/phone/storeAdsManage.vue')
    },
    {
        path: '/pages/phone/storeMsgManage',
        name: '/pages/phone/storeMsgManage',
        component: () => import('@/views/phone/storeMsgManage.vue')
    }
] 